<template>
  <div>
    <!-- Desktop Left Sidebar Rail (Untouched & Always Functional on Desktop >= 992px) -->
    <aside class="menu-bg influencer-sidebar" :class="showSlideBar ? 'offcanvas offcanvas-right show' : 'offcanvas offcanvas-right '"
           id="side_bar">
      <div class="text-right py-4 mx-2">
        <img class="btn-close" src="@/assets/images/stella/close.png" @click="$emit('menuClicked')">
      </div>
      <nav class="mt-2 px-3">

        <router-link active-class="active" class="d-flex align-items-center justify-content-between menu-item mb-1"
                     :to="{ name: 'CreatorMessageDashboard'}">
          <div class="d-flex align-items-center" >
            <div style="width: 24px; display: flex; justify-content: center; font-size: 20px;">💬</div>
            <div class="text-white ms-3 menu-label">Message</div>
          </div>
          <div v-if="unreadMessageCount > 0" class="btn btn-sm bg-danger-light rounded-pill text-danger font-size-12 text-center text-uppercase me-2 px-2 menu-badge">
            {{ unreadMessageCount }}
          </div>
        </router-link>

        <router-link exact active-class="active" class="d-flex align-items-center justify-content-between menu-item mb-1"
                     :to="{ name: 'CustomRequestList'}" replace>
          <div class="d-flex align-items-center">
            <div style="width: 24px; display: flex; justify-content: center; font-size: 20px;">🎁</div>
            <div class="text-white ms-3 menu-label">Custom Requests</div>
          </div>
          <div v-if="pendingCustomRequests > 0"
               class="btn btn-sm bg-success-light rounded-pill text-success font-size-12 text-center text-uppercase me-2 px-2 menu-badge">
            {{ pendingCustomRequests }}
          </div>
        </router-link>

        <router-link active-class="active" class="d-flex align-items-center justify-content-between menu-item mb-1"
                     :to="{ name: 'CreatorDashboardMobile'}" replace>
          <div class="d-flex align-items-center">
            <div style="width: 24px; display: flex; justify-content: center; font-size: 20px;">👥</div>
            <div class="text-white ms-3 menu-label">Manage Fans</div>
          </div>
        </router-link>

        <router-link active-class="active" class="d-flex align-items-center justify-content-between menu-item mb-1"
                     :to="{ name: 'BonusContentList'}" replace>
          <div class="d-flex align-items-center">
            <div style="width: 24px; display: flex; justify-content: center; font-size: 20px;">🛍️</div>
            <div class="text-white ms-3 menu-label">Bonus Content</div>
          </div>
        </router-link>

        <router-link active-class="active" class="d-flex align-items-center justify-content-between menu-item mb-1"
                     :to="{ name: 'CustomRequestOptionList'}" replace>
          <div class="d-flex align-items-center">
            <div style="width: 24px; display: flex; justify-content: center; font-size: 20px;">🛠️</div>
            <div class="text-white ms-3 menu-label">Custom Request Options</div>
          </div>
        </router-link>


        <router-link active-class="active" class="d-flex align-items-center justify-content-between menu-item mb-1"
                     :to="{ name: 'RecentTransactionMobile'}" replace>
          <div class="d-flex align-items-center">
            <div style="width: 24px; display: flex; justify-content: center; font-size: 20px;">💸</div>
            <div class="text-white ms-3 menu-label">Recent Transactions</div>
          </div>
        </router-link>


        <router-link active-class="active" class="d-flex align-items-center justify-content-between menu-item mb-1"
                     :to="{ name: 'BillingMobile'}" replace>
          <div class="d-flex align-items-center">
            <div style="width: 24px; display: flex; justify-content: center; font-size: 20px;">💳</div>
            <div class="text-white ms-3 menu-label">Billing</div>
          </div>
        </router-link>


        <router-link active-class="active" class="d-flex align-items-center justify-content-between menu-item mb-1"
                     :to="{ name: 'SettingsMobile'}" replace>
          <div class="d-flex align-items-center">
            <div style="width: 24px; display: flex; justify-content: center; font-size: 20px;">⚙️</div>
            <div class="text-white ms-3 menu-label">Account Settings</div>
          </div>
        </router-link>


        <router-link active-class="active" class="d-flex align-items-center justify-content-between menu-item mb-1"
                     :to="{ name: 'BlockedFriendsMobile'}" replace>
          <div class="d-flex align-items-center">
            <div style="width: 24px; display: flex; justify-content: center; font-size: 20px;">🚫</div>
            <div class="text-white ms-3 menu-label">Blocked Fans</div>
          </div>
        </router-link>

        <router-link active-class="active" class="d-flex align-items-center justify-content-between menu-item mb-1"
                     :to="{ name: 'HelpMobile'}" replace>
          <div class="d-flex align-items-center">
            <div style="width: 24px; display: flex; justify-content: center; font-size: 20px;">ℹ️</div>
            <div class="text-white ms-3 menu-label">Help</div>
          </div>
        </router-link>
        <logout-menu></logout-menu>

        <div class="py-5 invisible"></div>
      </nav>
    </aside>

    <!-- Mobile Instagram-Style Bottom Tab Bar (< 992px) -->
    <bottom-tab-bar
      :tabs="creatorTabs"
      :message-count="unreadMessageCount"
      :pending-requests-count="pendingCustomRequests"
      :is-more-active="showMore"
      @toggle-more="showMore = !showMore"
    />

    <!-- Mobile Instagram-Style More Menu Bottom Sheet (< 992px) -->
    <more-menu
      :visible="showMore"
      :items="moreItems"
      @close="showMore = false"
    />
  </div>
</template>

<script>
import LogoutMenu from "@/components/module/shared/LogoutMenu";
import BottomTabBar from "@/components/module/shared/BottomTabBar";
import MoreMenu from "@/components/module/shared/MoreMenu";
import { httpMixin } from "@/mixin/http-mixin";
import { SERVICE_CONTENT, SERVICE_DIRECT_MESSAGE } from "@/properties/micro-service";
import { CREATOR_BOTTOM_TABS, CREATOR_MORE_ITEMS } from "@/config/navigation-tabs";
import { mapGetters } from "vuex";

export default {
  props: ['showSlideBar'],
  name: "InfluencerMenu",
  mixins: [httpMixin],
  components: {
    LogoutMenu,
    BottomTabBar,
    MoreMenu
  },
  data() {
    return {
      pendingCustomRequests: 0,
      unreadMessageCount: 0,
      showMore: false,
      creatorTabs: CREATOR_BOTTOM_TABS,
      moreItems: CREATOR_MORE_ITEMS,
      isAnimate: true,
      pollInterval: null,
    }
  },
  created() {
    this.pollInterval = setInterval(() => {
      this.animate();
    }, 1000);
    document.body.classList.add('has-sidebar');
    this.fetchCounts();
  },
  destroyed() {
    clearInterval(this.pollInterval);
    document.body.classList.remove('has-sidebar');
  },
  computed: {
    ...mapGetters(['getUser']),
  },
  methods: {
    animate() {
      this.isAnimate = !this.isAnimate;
    },
    fetchCounts() {
      const user = this.getUser;
      if (user && user.id) {
        const countUrl = `${SERVICE_CONTENT}/api/v1/influencers/${user.id}/custom-request/count`;
        this.getData(countUrl, (count) => {
          this.pendingCustomRequests = count || 0;
        });

        const msgUrl = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${user.id}/unread-count`;
        this.getData(msgUrl, (count) => {
          this.unreadMessageCount = count || 0;
        });
      }
    }
  },
  watch: {
    showSlideBar: function (newVal) {
      if (newVal) {
        this.fetchCounts();
      }
    }
  }
}
</script>

<style scoped>
.new-shake {
  background: #55EFC4;
  padding: 2px 7px;
  font-size: 12px;
  color: #000;
  border-radius: 4px;
  animation: shake 0.8s;
}

.new-no-shake {
  background: #55EFC4;
  padding: 2px 7px;
  font-size: 12px;
  color: #000;
  border-radius: 4px;
}

@keyframes shake{
  0%{
    transform: translateX(0);
  }
  25%{
    transform: translateX(25px);
  }
  50%{
    transform: translateX(-25px);
  }
  100%{
    transform: translateX(0px);
  }
}
</style>

